import BaseButton from '@/components/BaseButton'
import Pager from '@/components/PagerComponent'

export default {

  components: {
    BaseButton,
    Pager
  },

  data () {
    return {
      permissions: JSON.parse(sessionStorage.getItem('user')).permissions,
      distributors: [],
      displayedDistributors: [],
      responseErr: '',
      error: false,
      validationError: false,
      isProcessing: false
    }
  },

  created () {
    this.getDistributors()
  },

  methods: {
    hasPermission (permission) {
      if (!String.prototype.includes) {
        return this.permissions.indexOf(permission, 0) !== -1
      } else {
        return this.permissions.includes(permission)
      }
    },
    async getDistributors () {
      if (!this.$store.state.distributors.distributors.length) {
        this.isProcessing = true
        this.error = false

        await this.$store.dispatch('distributors/reset')
        await this.$store.dispatch('distributors/search').then(
          () => {
            this.isProcessing = false
          },
          error => {
            this.isProcessing = false
            this.error = true
            this.responseErr = error || 'error.BAD_REQUEST'
          }
        )
      }
    },

    async editDistributor (distributor) {
      this.$store.dispatch('distributors/setDistributor', distributor)
      this.$router.push({ name: 'distributor-edit' })
    },

    async showCreate (distributor) {
      this.$store.dispatch('distributors/setDistributor', distributor)
      this.$router.push({ name: 'product-create' })
    },
  }
}
